module.exports = __webpack_public_path__ + "img/home-05-panoramic-layer-03.a5d6eeba.png";